export enum TypesInput {
  /* marks <form /> element */
  form,
  /* marks a block that wraps input related component, mainly use in portal input component like <PortalInput /> */
  'form-control',
  /* marks <input /> element */
  input,
  /* marks <select /> element or similar  
     for example it's use to mark <div role="combobox" /> (which is the clickable parts) in MUI <Selec /> component */
  select,
}

export enum TypesDisplay {
  /* marks page view (for each route) */
  view,
  /* marks a target container */
  block,
  /* marks a item that rendered by iterating (for example Array.map()) */
  item,
  /* marks a dialog */
  dialog,
  /* marks a popup / popover */
  popover,
  /* marks any label */
  label,
  /* marks any text content */
  text,
  /* marks any hint component (error message, helper text) */
  hint,
  /* marks any decorative parts of component */
  adornment,
  /* marks big wording like title, subtitle, description */
  typography,
  /* marks target image */
  image,
}

export enum TypesAction {
  /* marks menu wrapper */
  menu,
  /* marks any button likes component
     (button, link-like button, any click to action item, or clickable item that change SPA routes) */
  'btn-like',
  /* marks option, usually wrapped in menu */
  option,
  /* marks real href (mainly for external link that open other page / tab)*/
  link,
}

export type AllTypes =
  | keyof typeof TypesInput
  | keyof typeof TypesDisplay
  | keyof typeof TypesAction;

export type Nodes = (string | number | undefined)[];

export function generateTestIdValue(type: AllTypes, nodes?: Nodes) {
  return ['vs', type, ...(nodes ?? [])].filter(Boolean).map(String).join('-');
}
